import React from 'react';
import './impressum.css';
import { Header } from '../../components/header/Header';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';

const Impressum = () => {
	return (
		<div>
			<Header />
			<section className='impressum-section'>
				<div className='impressum-container'>
					<h1 className='impressum-title'>Impressum</h1>

					<div className='impressum-content'>
						<p>
							<strong>Anbieter:</strong> Health365 IT GmbH
						</p>
						<p>
							<strong>Adresse:</strong> Unter den Linden 10, 10117 Berlin
						</p>
						<p>
							<strong>E-Mail:</strong>{' '}
							<a href='mailto:master@erledix.de' className='link-style'>
								master@erledix.de
							</a>
						</p>
						<p>
							<strong>Website:</strong>{' '}
							<a
								href='https://www.h365.de'
								target='_blank'
								rel='noopener noreferrer'
								className='link-style'
							>
								www.h365.de
							</a>
						</p>

						<p>
							<strong>Verantwortlich für den Inhalt:</strong> Health365 IT GmbH
						</p>

						<h2>Haftungsausschluss</h2>
						<p>
							Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
							für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
							sind ausschließlich deren Betreiber verantwortlich.
						</p>

						<h2>Urheberrecht</h2>
						<p>
							Alle Inhalte dieser Website (Texte, Bilder, Grafiken, Design)
							unterliegen dem Urheberrecht und dürfen nur mit ausdrücklicher
							schriftlicher Genehmigung verwendet werden.
						</p>
					</div>
				</div>
			</section>
			<MobileFooter />
		</div>
	);
};

export default Impressum;
